export const convertPersian = (n: number) => n.toLocaleString('fa-IR');
